var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bell-solid",
    d: "M10.518,0a1.5,1.5,0,0,0-1.5,1.5v.9a7.5,7.5,0,0,0-6,7.35v.881A9.022,9.022,0,0,1,.745,16.613L.4,17a1.5,1.5,0,0,0,1.12,2.5h18a1.5,1.5,0,0,0,1.12-2.5l-.347-.389a9.013,9.013,0,0,1-2.273-5.981V9.75a7.5,7.5,0,0,0-6-7.35V1.5A1.5,1.5,0,0,0,10.518,0Zm2.123,23.123A3,3,0,0,0,13.518,21h-6a3,3,0,0,0,5.123,2.123Z",
    transform: "translate(-0.019)",
    fill: "#8e9ea0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSolid);
export default __webpack_public_path__ + "static/media/bell-solid.6f62e8b54d75dbb8bbd154bfafd008a8.svg";
export { ForwardRef as ReactComponent };